<script setup lang="ts">
import PanelGroup from '../PanelGroup.vue'
import { COMING_SOON_HOME_BLOCKS, visibleHomeBlocks } from '../../lib/brandAppContract'
import { HOME_BLOCK_SECTIONS } from '../../lib/brandAppSections'
import useBrandAppConfig from '../../composables/useBrandAppConfig'
import OrderedSubsetList from '../OrderedSubsetList.vue'

defineProps<{ highlightId?: string | null; title?: string }>()

const { home, homeBlockOrder, setHomeBlocks, setHomeBlockOrder } = useBrandAppConfig()

const { t } = useI18n()

const items = computed(() =>
  visibleHomeBlocks().map((block) => ({ id: block.id, label: block.label, icon: HOME_BLOCK_SECTIONS[block.id].icon }))
)
</script>

<template>
  <PanelGroup :title="title">
    <div class="flex flex-col gap-3">
      <OrderedSubsetList
        :items="items"
        :model-value="home.blocks"
        :order="homeBlockOrder"
        :highlight-id="highlightId"
        :disabled-ids="COMING_SOON_HOME_BLOCKS"
        :disabled-hint="t('pages.loyaltySupports.webapp.editor.screens.comingSoon')"
        @update:model-value="setHomeBlocks"
        @update:order="setHomeBlockOrder"
      />
      <p class="text-muted-foreground text-xs">
        {{ t('pages.loyaltySupports.webapp.editor.structure.home.hint') }}
      </p>
    </div>
  </PanelGroup>
</template>
